import ActionType from 'store/_utils/classes/ActionType';

import type IActionType from 'store/_utils/interfaces/IActionType';

class AppsTypes {
  static getAccessApp: IActionType = new ActionType('APPS/GET_ACCESS_APPS');
}

export default AppsTypes;
